import { Component, input } from '@angular/core';
import type { SectionBackground } from '../../models/site-api.model';

@Component({
  selector: 'app-section-wrapper',
  imports: [],
  templateUrl: './section-wrapper.component.html',
  styleUrl: './section-wrapper.component.scss',
})
export class SectionWrapperComponent {
  readonly id = input<string>('');
  readonly title = input<string>('');
  readonly subtitle = input<string>('');
  readonly eyebrow = input<string>('');
  readonly background = input<SectionBackground>('white');
  readonly titleAlign = input<'left' | 'center'>('center');
  readonly narrow = input<boolean>(false);
}
